import { get } from 'lodash';

export const parseChannelId = (pathname = '') => {
  return Number(
    get(pathname.match(/channel\/(\d+)/), [1]) || get(pathname.match(/vod-channel\/(\d+)/), [1]),
  );
};
export const parseProgramStartTime = (pathname = '') => {
  return (
    get(pathname.match(/channel\/\d+\/(\S+)/), [1]) ||
    get(pathname.match(/vod-channel\/\d+\/(\S+)/), [1])
  );
};

export default { parseChannelId, parseProgramStartTime };
